import React, { Component } from "react";
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import ViewIcon from '@material-ui/icons/Visibility';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { Row, Col } from "shards-react";
import { withStyles } from "@material-ui/core/styles";
import ShiftEmailPreview from "./ShiftEmailPreview";

const useStyles = theme => ({
	option:{
		  fontWeight: 600,	
		  fontSize:'0.75rem',
	},
	helperText:{
		fontWeight: 700,	
		color: 'orange',
		fontStyle:'italic',
		fontSize:'0.7rem'
	},
	checkbox:{
	    width: 8,
	    height: 8,
		marginLeft: 8
	},
	menu:{
	  fontSize:'0.75rem',
	},
});

class Schedule extends React.Component {
    constructor(props) {
      super(props);
      this.state = {schedule:{provider:{business_name: '', phone: '', email:''}, shift_date:'', start_date: "", end_date: "", custom_address_confirmed: false}}
  	}

    componentDidMount() {
    }

	componentWillReceiveProps(nextProps) {
		this.setState({shift_date: nextProps.schedule.shift_date})
	}

    handleChange = (e) =>{
    	var schedule = this.state.schedule
    	schedule.shift_date = e.target.value
		if (e.target.name  === 'custom_address_confirmed' || e.target.name  === 'shift_additional_notes_confirmed' ){
			e.target.value = e.target.checked
		}
    	this.props.onScheduleChange(e.target.name, e.target.value)
    	this.setState({schedule: schedule})
    }

    handleProviderPopOver = (e, open) => {
		this.setState({anchorElPopOver: open})
    }
    handleProviderPopOverShift = (e, open) => {
		this.setState({anchorElPopOverShift: open})
    }

	render() {
		const schedule = this.props.schedule
	    const anchorElPopOver = this.state.anchorElPopOver;
	  	const openPopOver = Boolean(anchorElPopOver);
		const anchorElPopOverShift = this.state.anchorElPopOverShift;
		const openPopOverShift = Boolean(anchorElPopOverShift);
		const classes = this.props.classes;
		return(
			<React.Fragment>
				{(schedule.provider.business_name)
					?
						<React.Fragment>
							<TextField
							  	id="shift_date"
							  	name="shift_date"
							  	onChange={this.handleChange}
							  	type="datetime-local"
							  	value={schedule.shift_date}
							  	margin="normal"
							  	className="mr-2 mt-0"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{width: 150, fontSize: '0.75rem'}}}
								InputProps={{
							    	startAdornment: <InputAdornment position="start">
										<Typography variant="caption">Turno</Typography>
										{(schedule.shift_date !== '')
										?
											<ShiftEmailPreview shift_date={schedule.shift_date} address={schedule.custom_address} id={this.props.work_order_id} show_resend={schedule.q_shift_sent > 0} shift_additional_notes={schedule.shift_additional_notes}/>
										:
											''
										}
										{schedule.shift_desired && <InfoIcon fontSize="small" onClick={(e) => this.handleProviderPopOverShift(e,  e.currentTarget)} />}
									</InputAdornment>,
								}}
							/>
							<Popover
								id="shift_popover"
								open={openPopOverShift}
								anchorEl={anchorElPopOverShift}
								onClose={(e)=>{this.handleProviderPopOverShift(e, null)}}
								anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'center',
								}}
								transformOrigin={{
								vertical: 'top',
								horizontal: 'center',
								}}
								>
								<div className="p-2">
									<Row>
										<Col>
											<TextField
												id="shift_desired"
												name="shift_desired"
												disabled={true}
												value={schedule.shift_desired}
												margin="normal"
												className="mr-2 mt-0"
												InputLabelProps={{
													shrink: true
												}}
												inputProps={{style:{fontSize: '0.75rem'}}}
									          	InputProps={{
										            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Turno deseado</Typography></InputAdornment>,
				          						}}
											/>
										</Col>
									</Row>
								</div>
							</Popover>									

							<TextField
							  	id="provider"
							  	name="provider"
							  	onChange={this.handleChange}
							  	disabled={true}
							  	type="provider"
							  	value={schedule.provider.business_name}
							  	margin="normal"
							  	className="mr-2 mt-0"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{fontSize: '0.75rem'}}}
								InputProps={{
//							    	startAdornment: <InputAdornment position="start" ><Typography variant="caption"></Typography></InputAdornment>,
						            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Proveedor <ViewIcon fontSize="small" onClick={(e)=> {this.handleProviderPopOver(e, e.currentTarget)}} /></Typography></InputAdornment>,
								}}
							/>
							<Popover
								id="provider_popover"
								open={openPopOver}
								anchorEl={anchorElPopOver}
								onClose={(e)=>{this.handleProviderPopOver(e, null)}}
								anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'center',
								}}
								transformOrigin={{
								vertical: 'top',
								horizontal: 'center',
								}}
								>
								<div className="p-2">
									<Row>
										<Col>
											<TextField
												id="provider_fantasy_name"
												name="provider_fantasy_name"
												value={schedule.provider.fantasy_name}
												margin="normal"
												className="mr-2 mt-0"
												InputLabelProps={{
													shrink: true
												}}
												inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
									          	InputProps={{
										            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Nombre fantasia</Typography></InputAdornment>,
				          						}}
											/>
										</Col>
									</Row>
									<Row>
										<Col>
											<TextField
												id="provider_fantasy_name"
												name="provider_fantasy_name"
												value={schedule.provider.phone}
												margin="normal"
												className="mr-2 mt-0"
												InputLabelProps={{
													shrink: true
												}}
												inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
									          	InputProps={{
										            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Telefono</Typography></InputAdornment>,
				          						}}
											/>
										</Col>
									</Row>
									<Row>
										<Col>
											<TextField
												id="provider_fantasy_name"
												name="provider_fantasy_name"
												value={schedule.provider.email}
												margin="normal"
												className="mr-2 mt-0"
												InputLabelProps={{
													shrink: true
												}}
												inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
									          	InputProps={{
										            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Mail</Typography></InputAdornment>,
				          						}}
											/>
										</Col>
									</Row>
								</div>
							</Popover>							

							<TextField
								id="custom_address"
								name="custom_address"
								onChange={this.handleChange}
								type="text"
								value={schedule.custom_address}
								disabled={!schedule.custom_address_confirmed}
								margin="normal"
								className="mr-2 mt-0"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{fontSize: '0.75rem', width: 300}}}
								InputProps={{
									startAdornment: <InputAdornment position="start" >
														<Typography variant="caption">
															Dirección Alternativa
														</Typography>
														<Checkbox
															id="custom_address_confirmed"
															name="custom_address_confirmed"
															className={classes.checkbox}
															onChange={this.handleChange}
															value={schedule.custom_address_confirmed}
															checked={schedule.custom_address_confirmed}
															color="primary"
															inputProps={{ 'aria-label': 'secondary checkbox' }}
														/>			            				

													</InputAdornment>,
								}}
							/>
							<TextField
								id="shift_additional_notes"
								name="shift_additional_notes"
								onChange={this.handleChange}
								type="text"
								fullWidth
								value={schedule.shift_additional_notes}
								disabled={!schedule.shift_additional_notes_confirmed}
								margin="normal"
								className="mr-2 mt-0"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{fontSize: '0.75rem'}}}
								InputProps={{
									startAdornment: <InputAdornment position="start" >
														<Typography variant="caption">
															Notas adicionales
														</Typography>
														<Checkbox
															id="shift_additional_notes_confirmed"
															name="shift_additional_notes_confirmed"
															className={classes.checkbox}
															onChange={this.handleChange}
															value={schedule.shift_additional_notes_confirmed}
															checked={schedule.shift_additional_notes_confirmed}
															color="primary"
															inputProps={{ 'aria-label': 'secondary checkbox' }}
														/>			            				

													</InputAdornment>,
								}}
							/>							
						</React.Fragment>
					:
						''
				}



			</React.Fragment>

		)

	}

}

export default withStyles(useStyles)(Schedule);
